import { Component } from '@angular/core';

@Component({
  selector: 'hr[joii-divider]',
  imports: [],
  template: ``,
  styleUrl: './divider.component.scss',
})
export class DividerComponent {}
